import { render } from "./component.vue?vue&type=template&id=70fa13b0&ts=true"
import script from "./component.vue?vue&type=script&lang=ts"
export * from "./component.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__